module.exports = "/_next/static/images/game-1-intro-tutorial-paper-uv-9f6ea7dc318da5849756e1dab618c3a2.png";